import { useState } from 'react'

export default function TreeNode ({ nodeKey, value, depth }) {
  const [open, setOpen] = useState(depth < 2)

  const isObject = value !== null && typeof value === 'object' && !Array.isArray(value)
  const isArray = Array.isArray(value)
  const isLeaf = !isObject && !isArray

  const keyEl = nodeKey !== null
    ? (
    <span className="dv-tree-key">"{nodeKey}"</span>
      )
    : null

  const colon = nodeKey !== null ? <span className="dv-tree-colon">:</span> : null

  if (isLeaf) {
    let valEl
    if (typeof value === 'string') valEl = <span className="dv-tree-str">"{value}"</span>
    else if (typeof value === 'number') valEl = <span className="dv-tree-num">{String(value)}</span>
    else if (typeof value === 'boolean') valEl = <span className="dv-tree-bool">{String(value)}</span>
    else valEl = <span className="dv-tree-null">null</span>

    return (
      <div className="dv-tree-node">
        {keyEl}{colon}{valEl}
      </div>
    )
  }

  const bracket = isArray ? ['[', ']'] : ['{', '}']
  const entries = isArray ? value.map((v, i) => [i, v]) : Object.entries(value)
  const count = entries.length

  return (
    <div className="dv-tree-node">
      <button className="dv-tree-toggle" onClick={() => setOpen((o) => !o)} aria-label={open ? 'collapse' : 'expand'}>
        <i className={`fa fa-chevron-${open ? 'down' : 'right'}`} />
      </button>
      {keyEl}{colon}
      <span className="dv-tree-bracket">{bracket[0]}</span>
      {!open && (
        <span className="dv-tree-collapsed-hint">
          {count} {count === 1 ? 'item' : 'items'}
        </span>
      )}
      {!open && <span className="dv-tree-bracket">{bracket[1]}</span>}
      {open && (
        <>
          <div className="dv-tree-children">
            {entries.map(([k, v]) => (
              <TreeNode key={String(k)} nodeKey={isArray ? null : String(k)} value={v} depth={depth + 1} />
            ))}
          </div>
          <span className="dv-tree-bracket">{bracket[1]}</span>
        </>
      )}
    </div>
  )
}
